/*eslint-disable*/

import React , {useState} from "react";
import "../../Assests/Globalcss/stylesheet.css";
import logo from "../../Assests/Globalimages/logo_v.jpg";
import { useNavigate } from "react-router-dom";
import CalculatorModal from "../CalculatorModal";
const employees = localStorage.getItem("employees");
const program = localStorage.getItem("program");


const index = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);


  const handleCalculateClick = () => {
      setShowModal(true);
  };

  const handleCloseModal = () => {
      setShowModal(false);
  };

  return (
    <div>
      <section class="nav-bar">
      {showModal && (
        <CalculatorModal showModal={showModal} setShowModal={setShowModal} handleCloseModal={handleCloseModal} />
            )}
        <div class="container">
          <nav class="navbar navbar-expand-lg fixed-top bg-white bg-body-tertiary shadow">
            <div class="container">
              <a href="/">
                <img src={logo} style={{ maxWidth: "180px" }} />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div
                class="collapse navbar-collapse justify-content-end"
                id="navbarNav"
              >
                <ul class="navbar-nav align-items-center">
                  {/* <li class="nav-item">
                    <a
                      onClick={() => {
                        !employees && !program ? navigate("/Pre-Qualifier") : navigate("/Health-Program")
                      }}
                      class="nav-link"
                      style={{ cursor: "pointer" }}
                    >
                      Health Programs
                    </a>
                  </li> */}
                  <li class="nav-item">
                    <a
                      onClick={() => navigate("/grants")}
                      class="nav-link"
                      style={{ cursor: "pointer" }}
                    >
                      Grants
                    </a>
                  </li>
                 <li class="nav-item">
                    <a
                      onClick={() => setShowModal(true)}
                      class="nav-link cardbtun asd px-3 py-2"
                      style={{ cursor: "pointer" }}
                    >
                      Get Started
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="mailto:office@venturerev.com"
                      class="cardbtun asd px-3 py-2 "
                      style={{ texDecoration: "none" }}
                    >
                      Contact us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </section>
    </div>
  );
};

export default index;
